import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getAcceptanceToDay = createAsyncThunk(
  'acceptanceToDay/getAcceptanceToDay',
  async (formData = {}, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/co/acceptance_to_day', { params: { ...formData } });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export default getAcceptanceToDay;
